"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.string.sub.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.object.values.js");

require("regenerator-runtime/runtime.js");

var _toConsumableArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _socket = _interopRequireDefault(require("@/assets/js/socket.js"));

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _markets = require("@/model/markets/markets");

var _settings = require("@/model/settings");

var _vuex = require("vuex");

var _index2 = require("@/model/exchange/index");

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _keymap = require("@/assets/js/keymap.js");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _stationSetting = require("@/assets/js/stationSetting");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { apiGetSpotList } from "@/model/exchange/market.js";
var _default = {
  mixins: [_commonMixin.default],
  components: {
    NoData: _NoData.default
  },
  data: function data() {
    return {
      systemCurrencyMaps: _keymap.systemCurrencyMaps,
      voucherInterval: null,
      activeName: "2",
      activeSymbol: "1",
      // activeContract: "1",
      selectSymbol: "",
      infoForm: {},
      loading: false,
      tableLoading: true,
      hasBusd: false,
      formLoadng: true,
      tableDataComputed: [],
      collectSymbol: [22],
      tableData: [],
      options: [],
      symbolList: [],
      expandList: [],
      coinInfoList: {},
      coinInfoListThirTeen: {},
      exchangeCoinMap: {},
      coinInfoMap: {},
      exchangeInfoMap: {},
      wsUrl: "",
      coinInfo: "",
      headerFormSymbolList: [],
      headerForm: {},
      // headerForm: {
      //   71: {
      //     coin_url:
      //       "https://imgs-dev.aevwjlae.com/admin/20210211/92752491010.png",
      //     symbol_id: 71,
      //     from_symbol: "LINK",
      //     to_symbol: "USDT",
      //     ask: "--",
      //     bid: "--",
      //     vol: "0",
      //     last: "--",
      //     price_change_percent: "--",
      //     currency: {
      //       ued: "--",
      //       cny: "--",
      //       cnye: "--",
      //       hkd: "--",
      //       jpy: "--",
      //       krw: "--",
      //       usd: "--",
      //     },
      //   },
      //   74: {
      //     coin_url:
      //       "https://imgs-dev.aevwjlae.com/admin/20210401/83568193825.png",
      //     symbol_id: 74,
      //     from_symbol: "DOGE",
      //     to_symbol: "USDT",
      //     ask: "--",
      //     vol: "0",
      //     bid: "--",
      //     last: "--",
      //     price_change_percent: "--",
      //     currency: {
      //       ued: "--",
      //       cny: "--",
      //       cnye: "--",
      //       hkd: "--",
      //       jpy: "--",
      //       krw: "--",
      //       usd: "--",
      //     },
      //   },
      //   22: {
      //     coin_url:
      //       "https://imgs-dev.aevwjlae.com/admin/20201113/03397235421.png",
      //     symbol_id: 22,
      //     from_symbol: "BTC",
      //     to_symbol: "USDT",
      //     last: "--",
      //     ask: "",
      //     bid: "",
      //     vol: "0",
      //     price_change_percent: "--",
      //     currency: {
      //       ued: "--",
      //       cny: "--",
      //       cnye: "--",
      //       hkd: "--",
      //       jpy: "--",
      //       krw: "--",
      //       usd: "--",
      //     },
      //   },
      //   23: {
      //     coin_url:
      //       "https://imgs-dev.aevwjlae.com/admin/20201113/03397388660.png",
      //     symbol_id: 23,
      //     from_symbol: "ETH",
      //     to_symbol: "USDT",
      //     ask: "--",
      //     bid: "--",
      //     vol: "0",
      //     price_change_percent: "--",
      //     last: "--",
      //     currency: {
      //       ued: "--",
      //       cny: "--",
      //       cnye: "--",
      //       hkd: "--",
      //       jpy: "--",
      //       krw: "--",
      //       usd: "--",
      //     },
      //   },
      // },
      ws: null,
      selfOptionsList: [],
      market: [],
      contractM: [],
      futureM: [],
      allSelf: [],
      marketSelf: [],
      contractSelf: [],
      httpContractList: [],
      httpFutureList: [],
      httpExchangeList: []
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    systemCurrency: "user/currency",
    language: "user/language"
  })), {}, {
    tableDataShow: function tableDataShow() {
      // let tempArr = [];
      // if (this.activeName == "1") {
      //   tempArr = this.tableData.filter(entry => {
      //     if (this.selfOptionsList.indexOf(entry.symbol_id.toString()) != -1) {
      //       return entry;
      //     }
      //   });
      // } else tempArr = this.tableDataComputed;
      // return tempArr;
      return this.tableDataComputed;
    },
    className: function className() {
      var className = "";

      if (!this.headerForm[this.headerFormSymbolList[0]].price_change_percent) {
        className = "";
      } else if (this.headerForm[this.headerFormSymbolList[0]].price_change_percent > 0) {
        className = "green";
      } else if (this.headerForm[this.headerFormSymbolList[0]].price_change_percent < 0) {
        className = "red";
      }

      return className;
    },
    classNameV2: function classNameV2() {
      var className = "";

      if (!this.headerForm[this.headerFormSymbolList[1]].price_change_percent) {
        className = "";
      } else if (this.headerForm[this.headerFormSymbolList[1]].price_change_percent > 0) {
        className = "green";
      } else if (this.headerForm[this.headerFormSymbolList[1]].price_change_percent < 0) {
        className = "red";
      }

      return className;
    },
    classNameV3: function classNameV3() {
      var className = "";

      if (!this.headerForm[this.headerFormSymbolList[2]].price_change_percent) {
        className = "";
      } else if (this.headerForm[this.headerFormSymbolList[2]].price_change_percent > 0) {
        className = "green";
      } else if (this.headerForm[this.headerFormSymbolList[2]].price_change_percent < 0) {
        className = "red";
      }

      return className;
    },
    classNameV4: function classNameV4() {
      var className = "";

      if (!this.headerForm[this.headerFormSymbolList[3]].price_change_percent) {
        className = "";
      } else if (this.headerForm[this.headerFormSymbolList[3]].price_change_percent > 0) {
        className = "green";
      } else if (this.headerForm[this.headerFormSymbolList[3]].price_change_percent < 0) {
        className = "red";
      }

      return className;
    }
  }),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.initURL();

            case 2:
              _this.initWS();

              _this.getOptionList();

              _context.next = 6;
              return _this.getStaticTableInfo();

            case 6:
              _context.next = 8;
              return _this.getcontractFuturesList();

            case 8:
              _context.next = 10;
              return _this.getSpotList();

            case 10:
              _this.onResponse({
                action: "Pushdata.marketM",
                data: []
              }); // await this.getStaticTableInfo(1);
              // await this.getStaticTableInfoV2(13);


              _this.getExchangeCoinMap();

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    if (_stationSetting.VUE_UNION_STATION == "bitda") {
      var meta = document.getElementsByTagName("meta");
      meta["title"].setAttribute("content", "行情|幣達交易所");
      meta["description"].setAttribute("content", "加密貨幣市場 - 了解比特幣和其他加密貨幣的最新價格、代幣市值、代幣價格圖表以及 24 小時變化加密貨幣。");
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.voucherInterval);
  },
  destroyed: function destroyed() {
    clearInterval(this.voucherInterval);
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    getcontractFuturesList: function getcontractFuturesList() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$apiGetcontract, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _index2.apiGetcontractFuturesList)();

              case 2:
                _yield$apiGetcontract = _context2.sent;
                status = _yield$apiGetcontract.status;
                data = _yield$apiGetcontract.data;

                if (status == 200) {
                  _this2.httpContractList = data.contract;
                  _this2.httpFutureList = data.futures;
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getSpotList: function getSpotList() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetSpotList, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _index2.apiGetSpotList)();

              case 2:
                _yield$apiGetSpotList = _context3.sent;
                status = _yield$apiGetSpotList.status;
                data = _yield$apiGetSpotList.data;

                if (status == 200) {
                  _this3.httpExchangeList = data;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 千分符
    formatNumberRgx: function formatNumberRgx(num) {
      if (!num) {
        return;
      }

      var parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    getExchangeCoinMap: function getExchangeCoinMap() {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$apiGetStaticTa, coinInfoMap, _yield$apiGetStaticTa2, exchangeInfoMap, _yield$apiGetStaticTa3, status, data, tempObj, key, index, _key, symbolNameArray, _key2, _symbolNameArray, _key3, _index, _key4, _key5, _key6;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(49);

              case 2:
                _yield$apiGetStaticTa = _context4.sent;
                coinInfoMap = _yield$apiGetStaticTa.data;
                _this4.coinInfoMap = JSON.parse(JSON.stringify(coinInfoMap)); // 币本位合约

                _context4.next = 7;
                return (0, _settings.apiGetStaticTableInfo)(58);

              case 7:
                _yield$apiGetStaticTa2 = _context4.sent;
                exchangeInfoMap = _yield$apiGetStaticTa2.data;
                _this4.exchangeInfoMap = JSON.parse(JSON.stringify(exchangeInfoMap));
                _context4.next = 12;
                return (0, _settings.apiGetStaticTableInfo)(55);

              case 12:
                _yield$apiGetStaticTa3 = _context4.sent;
                status = _yield$apiGetStaticTa3.status;
                data = _yield$apiGetStaticTa3.data;

                if (status == 200) {
                  tempObj = {};

                  for (key in data) {
                    if (data[key].symbol_type == 1 && data[key].status == 1) {
                      tempObj[key] = data[key];
                    }
                  }

                  _this4.exchangeCoinMap = JSON.parse(JSON.stringify(tempObj));

                  for (index in _this4.coinInfoListThirTeen) {
                    //U本位合约
                    for (_key in _this4.coinInfoMap) {
                      if (_this4.coinInfoMap[_key].change_item_id == _this4.coinInfoListThirTeen[index].item_id) {
                        _this4.coinInfoMap[_key].from_item_name = _this4.coinInfoListThirTeen[index].item_name;
                        _this4.coinInfoMap[_key].from_coin_id = _this4.coinInfoListThirTeen[index].item_tag;
                      }

                      if (_this4.coinInfoMap[_key].base_item_id == _this4.coinInfoListThirTeen[index].item_id) {
                        _this4.coinInfoMap[_key].to_item_name = _this4.coinInfoListThirTeen[index].item_name;
                        _this4.coinInfoMap[_key].to_coin_id = _this4.coinInfoListThirTeen[index].item_tag;
                      }

                      symbolNameArray = _this4.coinInfoMap[_key].name.split("_");
                      _this4.coinInfoMap[_key].whole_name = symbolNameArray[0] + " " + _this4.translateTitle("永续") + "/" + symbolNameArray[1];
                      _this4.coinInfoMap[_key].type = "contract";
                    } //币本位合约


                    for (_key2 in _this4.exchangeInfoMap) {
                      if (_this4.exchangeInfoMap[_key2].change_item_id == _this4.coinInfoListThirTeen[index].item_id) {
                        _this4.exchangeInfoMap[_key2].from_item_name = _this4.coinInfoListThirTeen[index].item_name;
                        _this4.exchangeInfoMap[_key2].from_coin_id = _this4.coinInfoListThirTeen[index].item_tag;
                      }

                      if (_this4.exchangeInfoMap[_key2].base_item_id == _this4.coinInfoListThirTeen[index].item_id) {
                        _this4.exchangeInfoMap[_key2].to_item_name = _this4.coinInfoListThirTeen[index].item_name;
                        _this4.exchangeInfoMap[_key2].to_coin_id = _this4.coinInfoListThirTeen[index].item_tag;
                      }

                      _symbolNameArray = _this4.exchangeInfoMap[_key2].name.split("_");
                      _this4.exchangeInfoMap[_key2].whole_name = _symbolNameArray[0] + " " + _this4.translateTitle("永续") + "/" + _symbolNameArray[1];
                      _this4.exchangeInfoMap[_key2].type = "future";
                    } //币币


                    for (_key3 in _this4.exchangeCoinMap) {
                      if (_this4.exchangeCoinMap[_key3].coin_from == _this4.coinInfoListThirTeen[index].item_id) {
                        _this4.exchangeCoinMap[_key3].from_item_name = _this4.coinInfoListThirTeen[index].item_name;
                        _this4.exchangeCoinMap[_key3].from_coin_id = _this4.coinInfoListThirTeen[index].item_tag;
                      }

                      if (_this4.exchangeCoinMap[_key3].coin_to == _this4.coinInfoListThirTeen[index].item_id) {
                        _this4.exchangeCoinMap[_key3].to_item_name = _this4.coinInfoListThirTeen[index].item_name;
                        _this4.exchangeCoinMap[_key3].to_coin_id = _this4.coinInfoListThirTeen[index].item_tag;
                      }

                      _this4.exchangeCoinMap[_key3].whole_name = _this4.exchangeCoinMap[_key3].name;
                      _this4.exchangeCoinMap[_key3].type = "exchange";
                    }
                  }

                  for (_index in _this4.coinInfoList) {
                    //U本位合约
                    for (_key4 in _this4.coinInfoMap) {
                      if (_this4.coinInfoMap[_key4].from_coin_id == _this4.coinInfoList[_index].coin_id) {
                        _this4.coinInfoMap[_key4].coin_url = _this4.coinInfoList[_index].coin_url;
                      }
                    } //币本位合约


                    for (_key5 in _this4.exchangeInfoMap) {
                      if (_this4.exchangeInfoMap[_key5].from_coin_id == _this4.coinInfoList[_index].coin_id) {
                        _this4.exchangeInfoMap[_key5].coin_url = _this4.coinInfoList[_index].coin_url;
                      }
                    } //币币


                    for (_key6 in _this4.exchangeCoinMap) {
                      if (_this4.exchangeCoinMap[_key6].from_coin_id == _this4.coinInfoList[_index].coin_id) {
                        _this4.exchangeCoinMap[_key6].coin_url = _this4.coinInfoList[_index].coin_url;
                      }
                    }
                  }
                }

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    initWS: function initWS() {
      // this.tableLoading = true;
      var wsUrl = this.wsUrl;
      var option = {
        url: wsUrl,
        subData: {
          action: "Topic.sub",
          data: {
            type: "marketM",
            app_id: _stationSetting.VUE_APP_ID
          }
        },
        callback: this.onResponse,
        mounted: this.mounted
      };
      window.USDT_WS = this.ws = new _socket.default(option).getInstance();
    },
    mounted: function mounted() {
      var me = this;
      me.ws.sub({
        action: "Topic.sub",
        data: {
          type: "futureM",
          app_id: _stationSetting.VUE_APP_ID
        }
      });
      me.ws.sub({
        action: "Topic.sub",
        data: {
          type: "contractM",
          app_id: _stationSetting.VUE_APP_ID
        }
      });
    },
    getSubData: function getSubData() {
      var json = {
        data: {
          type: "marketM",
          app_id: _stationSetting.VUE_APP_ID
        },
        action: "Topic.sub"
      };
      this.ws.sub(json);
    },
    handleResPonse: function handleResPonse(data) {
      var _this5 = this;

      if (this.time == 1) {
        this.onResponse(data);
        this.time = 2;
      } else {
        setTimeout(function () {
          _this5.onResponse(data);
        }, 4000);
      }
    },
    initURL: function initURL() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, _yield$apiWsUrl, status, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  __version: "3.4.3"
                };
                _context5.next = 3;
                return (0, _index2.apiWsUrl)(params);

              case 3:
                _yield$apiWsUrl = _context5.sent;
                status = _yield$apiWsUrl.status;
                data = _yield$apiWsUrl.data;

                if (status == 200) {
                  _this6.wsUrl = data.ws3_url;
                }

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onResponse: function onResponse(data) {
      var _this7 = this;

      if (data.action == "Pushdata.marketM") {
        this.market = data.data;

        if (this.market == null || this.market.length == 0) {
          this.market = this.httpExchangeList;
        }

        this.headerFormSymbolList = [];
        this.market.forEach(function (ele) {
          ele.currency.usdV2 = Number(ele.currency.usd);
          ele.lastV2 = Number(ele.last);
          ele.price_change_percentV2 = Number(ele.price_change_percent); // ele.price_change_percentV2 = Number(ele.price_change_percent);

          ele.highV2 = Number(ele.high);
          ele.lowV2 = Number(ele.low);

          for (var key in _this7.exchangeCoinMap) {
            if (key == ele.symbol_id) {
              ele["from_symbol"] = _this7.exchangeCoinMap[key].name.split("_")[0].toUpperCase();
              ele["to_symbol"] = _this7.exchangeCoinMap[key].name.split("_")[1].toUpperCase();
              ele["info"] = _this7.exchangeCoinMap[key];
              ele["web_recommend"] = _this7.exchangeCoinMap[key].web_recommend;
              ele["isContract"] = false;
            }
          }

          ele.coin_url = "";

          for (var _key7 in _this7.coinInfoList) {
            if (ele.from_symbol) {
              if (_this7.coinInfoList[_key7].name == ele.from_symbol.toLowerCase()) {
                ele.coin_url = _this7.coinInfoList[_key7].coin_url;
              }
            }
          }

          if (ele.to_symbol && ele.to_symbol == "BUSD") {
            _this7.hasBusd = true;
          }

          if (ele.web_recommend == 1) {
            _this7.headerFormSymbolList.push(ele.symbol_id);

            _this7.headerForm[ele.symbol_id] = ele;

            for (var _key8 in _this7.headerForm) {
              _this7.headerForm[_key8].vol = Number(_this7.headerForm[_key8].vol).toFixed(2);
            }
          }
        }); //顶部4个展示不足

        if (this.headerFormSymbolList.length < 4) {
          this.headerFormSymbolList = [].concat((0, _toConsumableArray2.default)(this.headerFormSymbolList), (0, _toConsumableArray2.default)(this.headerFormSymbolList), (0, _toConsumableArray2.default)(this.headerFormSymbolList), (0, _toConsumableArray2.default)(this.headerFormSymbolList));
          this.headerFormSymbolList = this.headerFormSymbolList.slice(0, 4);
        }
      }

      if (data.action == "Pushdata.contractM") {
        this.contractM = data.data;

        if (this.contractM == null || this.contractM.length == 0) {
          this.contractM = this.httpContractList; // return;
        }

        this.contractM.forEach(function (ele) {
          ele.currency.usdV2 = Number(ele.currency.usd);
          ele.lastV2 = Number(ele.last);
          ele.price_change_percentV2 = Number(ele.price_change_percent);
          ele.highV2 = Number(ele.high);
          ele.lowV2 = Number(ele.low);

          for (var key in _this7.coinInfoMap) {
            if (key == ele.symbol_id) {
              ele["from_symbol"] = _this7.coinInfoMap[key].name.split("_")[0].toUpperCase();
              ele["to_symbol"] = _this7.coinInfoMap[key].name.split("_")[1].toUpperCase();
              ele["info"] = _this7.coinInfoMap[key]; // ele["web_recommend"] = this.coinInfoMap[key].web_recommend;

              ele["isContract"] = true;
            }
          }

          ele.coin_url = "";

          for (var _key9 in _this7.coinInfoList) {
            if (ele.from_symbol) {
              if (_this7.coinInfoList[_key9].name == ele.from_symbol.toLowerCase()) {
                ele.coin_url = _this7.coinInfoList[_key9].coin_url;
              }
            }
          }
        });
      }

      if (data.action == "Pushdata.futureM") {
        this.futureM = data.data;

        if (this.futureM == null || this.futureM.length == 0) {
          this.futureM = this.httpFutureList; // return;
        }

        this.futureM.forEach(function (ele) {
          ele.currency.usdV2 = Number(ele.currency.usd);
          ele.lastV2 = Number(ele.last);
          ele.price_change_percentV2 = Number(ele.price_change_percent);
          ele.highV2 = Number(ele.high);
          ele.lowV2 = Number(ele.low);

          for (var key in _this7.exchangeInfoMap) {
            if (key == ele.symbol_id) {
              ele["from_symbol"] = _this7.exchangeInfoMap[key].name.split("_")[0].toUpperCase();
              ele["to_symbol"] = _this7.exchangeInfoMap[key].name.split("_")[1].toUpperCase();
              ele["info"] = _this7.exchangeInfoMap[key]; // ele["web_recommend"] = this.coinInfoMap[key].web_recommend;

              ele["isContract"] = true;
            }
          }

          ele.coin_url = "";

          for (var _key10 in _this7.coinInfoList) {
            if (ele.from_symbol) {
              if (_this7.coinInfoList[_key10].name == ele.from_symbol.toLowerCase()) {
                ele.coin_url = _this7.coinInfoList[_key10].coin_url;
              }
            }
          }
        });
      }

      if (this.activeName == 1) {
        this.tableDataComputed = [].concat((0, _toConsumableArray2.default)(this.market), (0, _toConsumableArray2.default)(this.contractM), (0, _toConsumableArray2.default)(this.futureM)).filter(function (entry) {
          if (_this7.selfOptionsList.indexOf(entry.symbol_id.toString()) != -1) {
            return entry;
          }
        });
        this.tableLoading = false;
      } else if (this.activeName == 2) {
        this.tableDataComputed = this.market.filter(function (ele) {
          if (_this7.activeSymbol == 1) {
            return ele.from_symbol != undefined && ele.info.coin_to == "10007";
          } else if (_this7.activeSymbol == 2) {
            return ele.from_symbol != undefined && ele.info.coin_to == "10005";
          } else if (_this7.activeSymbol == 3) {
            return ele.from_symbol != undefined && ele.info.coin_to == "10123";
          } else if (_this7.activeSymbol == 10) {
            if (_this7.selfOptionsList.indexOf(ele.symbol_id.toString()) != -1) {
              return ele;
            }
          }
        });
        this.tableLoading = false;
      } else if (this.activeName == 3) {
        if (this.activeSymbol == 4) {
          this.tableDataComputed = this.contractM;
        } else if (this.activeSymbol == 5) {
          this.tableDataComputed = this.futureM;
        } else if (this.activeSymbol == 11) {
          this.tableDataComputed = [].concat((0, _toConsumableArray2.default)(this.contractM), (0, _toConsumableArray2.default)(this.futureM)).filter(function (entry) {
            if (_this7.selfOptionsList.indexOf(entry.symbol_id.toString()) != -1) {
              return entry;
            }
          });
        }

        this.tableLoading = false;
      }
    },
    onSymbolBlockClick: function onSymbolBlockClick(from_symbol, to_symbol) {
      var tempUrl = this.routeSplicing(this.language, "exchange/".concat(from_symbol.toLowerCase(), "_").concat(to_symbol.toLowerCase()));
      window.open(tempUrl);
    },
    onCellClick: function onCellClick(row, column, cell, event) {
      if (column.label == "" || column.label == this.translateTitle("操作")) {
        return;
      }

      var tempUrl = this.routeSplicing(this.language, "exchange/".concat(row.from_symbol.toLowerCase(), "_").concat(row.to_symbol.toLowerCase()));
      window.open(tempUrl);
    },
    onSymbolClick: function onSymbolClick(row) {
      var tempUrl = this.routeSplicing(this.language, "exchange/".concat(row.from_symbol.toLowerCase(), "_").concat(row.to_symbol.toLowerCase()));
    },
    onSymbolChange: function onSymbolChange(num) {
      if ((num == 10 || num == 11) && !this.userInfo) {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
      }

      this.activeSymbol = num;
      this.tableDataComputed = [];
      this.tableLoading = true;
    },
    onDetail: function onDetail(row, type) {
      if (type == 1) {
        this.expandList = [];
        this.expandList.push(row.symbol_id);
        this.getCoinInfo(row);
      } else {
        this.expandList = [];
      }
    },
    onFilterSymbol: function onFilterSymbol(val) {
      this.selectSymbol = val.replace(/[^a-zA-Z\d/]/g, "");
    },
    getCoinInfo: function getCoinInfo(row) {
      var _this8 = this;

      this.formLoadng = true;
      var params = {
        swap_symbol_id: row.symbol_id
      };
      (0, _markets.apiGetCoinInfo)(params).then(function (res) {
        if (res.status == 200) {
          _this8.infoForm[row.symbol_id] = res.data;
          _this8.coinInfo = _this8.infoForm[row.symbol_id].info;
        }

        _this8.formLoadng = false;
      });
    },
    addOption: function addOption(row, type) {
      var _this9 = this;

      if (this.userInfo) {
        var params = {
          symbol_id: row.symbol_id,
          option: type,
          swap_type: 2
        };
        (0, _markets.apiAddOption)(params).then(function (res) {
          if (res.status == 200) {
            _this9.getOptionList();

            _this9.$message({
              message: params.option == 1 ? _this9.translateTitle("添加自选成功") : _this9.translateTitle("删除自选成功"),
              type: params.option == 1 ? "success" : "success"
            });
          }
        });
      } else {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
      }
    },
    handleClick: function handleClick(tab, event) {
      if (tab.name == 1 && !this.userInfo) {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
      }

      if (tab.name == 2) {
        this.activeSymbol = 1;
      } else if (tab.name == 3) {
        this.activeSymbol = 4;
      }

      this.tableDataComputed = [];
      this.tableLoading = true;
    },
    getOptionList: function getOptionList() {
      var _this10 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$Account$getUse, userInfo, accountInfo;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Account.getUserInfo();

              case 2:
                _yield$Account$getUse = _context6.sent;
                userInfo = _yield$Account$getUse.userInfo;
                accountInfo = _yield$Account$getUse.accountInfo;

                if (userInfo) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return");

              case 7:
                (0, _markets.apiGetOptionList)().then(function (res) {
                  if (res.status == 200 && JSON.stringify(res.data) != "[]") {
                    if (res.data.digital) {
                      _this10.selfOptionsList = res.data.digital;
                    }
                  }
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    getStaticTableInfo: function getStaticTableInfo() {
      var _this11 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$apiGetStaticTa4, status1, coinInfoList, _yield$apiGetStaticTa5, status2, coinInfoListThirTeen;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(1);

              case 2:
                _yield$apiGetStaticTa4 = _context7.sent;
                status1 = _yield$apiGetStaticTa4.status;
                coinInfoList = _yield$apiGetStaticTa4.data;

                if (status1 == 200) {
                  _this11.coinInfoList = JSON.parse(JSON.stringify(coinInfoList));
                }

                _context7.next = 8;
                return (0, _settings.apiGetStaticTableInfo)(13);

              case 8:
                _yield$apiGetStaticTa5 = _context7.sent;
                status2 = _yield$apiGetStaticTa5.status;
                coinInfoListThirTeen = _yield$apiGetStaticTa5.data;

                if (status2 == 200) {
                  _this11.coinInfoListThirTeen = JSON.parse(JSON.stringify(coinInfoListThirTeen));
                }

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    remoteMethod: function remoteMethod(query) {
      var _this12 = this;

      query = query.trim();

      if (query !== "") {
        this.loading = true;
        setTimeout(function () {
          _this12.loading = false;
          var tempArr = [];
          tempArr = [].concat((0, _toConsumableArray2.default)(Object.values(_this12.exchangeCoinMap)), (0, _toConsumableArray2.default)(Object.values(_this12.coinInfoMap)), (0, _toConsumableArray2.default)(Object.values(_this12.exchangeInfoMap)));
          _this12.options = tempArr.filter(function (item) {
            if (item.from_item_name) {
              return item.from_item_name.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.to_item_name.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 || (item.from_item_name.toLowerCase() + item.to_item_name.toLowerCase()).indexOf(query.toLowerCase()) > -1;
            }
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    onselectBlur: function onselectBlur() {
      var _this13 = this;

      setTimeout(function () {
        _this13.options = [];
        _this13.selectSymbol = "";
      }, 1000);
    },
    onSelect: function onSelect(value) {
      var tempValue = "";

      if (value) {
        var tempUrl = "";

        if (value.type == "exchange") {
          tempValue = value.name.replace("/", "_").toLowerCase();
          tempUrl = this.routeSplicing(this.language, "exchange/".concat(tempValue));
        } else if (value.type == "contract") {
          tempValue = value.name.replace("_", "").toLowerCase();
          tempUrl = this.routeSplicing(this.language, "contract-exchange/".concat(tempValue));
        } else if (value.type == "future") {
          tempValue = value.name.replace("_", "").toLowerCase();
          tempUrl = this.routeSplicing(this.language, "delivery/".concat(tempValue));
        }

        window.open(tempUrl);
      }

      this.selectSymbol = "";
    }
  }
};
exports.default = _default;